import _ from 'lodash'
import { createAction, createReducer } from 'redux-act'
import axios from 'axios'
import qs from 'qs'
import l8n from 'l8n'
import Url from 'url-parse'

import { addSubmitForm, deleteSubmitForm } from 'ducks/app'
import { baseUrl } from 'scripts/env'
import { getGaClientId } from 'scripts/analytics'
import { login } from 'ducks/login'

export const REDUCER = 'registration';
const NS = `@@${REDUCER}/`;

export const togglePasswordVisibility = createAction(`${NS}TOGGLE_PASSWORD_VISIBILITY`)
export const googleSignUpSuccess = createAction(`${NS}GOOGLE_SIGNUP_SUCCESS`)
export const googleSignUpFailure = createAction(`${NS}GOOGLE_SIGNUP_FAILURE`)
export const emailSignUpSuccess = createAction(`${NS}EMAIL_SIGNUP_SUCCESS`)
export const registrationDone = createAction(`${NS}REGISTRATION_DONE`)
export const partnerRegistered = createAction(`${NS}PARTNER_REGISTERED`)
export const acceptTerms = createAction(`${NS}SET_TERMS_ACCEPTED`)

export const register = async (profile, dispatch) => {
  const ref = JSON.parse(window.localStorage.getItem('app.ref'));
  const parsed_url = new Url(profile.site_url, profile.site_url);
  const site_url = parsed_url.hostname || parsed_url.href || null;

  const params = _.omitBy({
    pricelist_id: l8n.priceListId,
    locale: l8n.locale,
    ...profile,
    ...ref,
    site_url,
    cid: getGaClientId(),
  }, _.isNull);

  var response = await axios({
      method: 'POST',
      url: `${baseUrl}/user/create`,
      data: qs.stringify(params)
  });

  let user = _.get(response, 'data.user', false);
  if (! user) {
      return false
  }

  dispatch(partnerRegistered(user))

  let logged = await login({
    email: profile.email,
    password: profile.password,
    idToken: profile.googleIdToken,
    dispatch,
  });
  if (! logged) {
    return false
  }

  return true
};

export const submit = profile => async (dispatch, getState) => {
  dispatch(addSubmitForm(REDUCER));
  await register(profile, dispatch, getState);
  dispatch(deleteSubmitForm(REDUCER));
  dispatch(registrationDone());
};

const initialState = {
  passwordVisible: false,
  googleSignUpErrorMessage: null,
  googleIdToken: null,
  email: null,
  password: null,
  name: null,
  termsAccepted: false,
};

export default createReducer(
  {
    [acceptTerms]:  (state, termsAccepted) => ({ ...state, termsAccepted }),
    [togglePasswordVisibility]: (state) => ({ ...state, passwordVisible: ! state.passwordVisible }),
    [googleSignUpFailure]: (state, msg) => ({ ...state, googleSignUpErrorMessage: msg }),
    [googleSignUpSuccess]: (state, { idToken, name }) => {
      return {
        ...state,
        googleSignUpErrorMessage: null,
        googleIdToken: idToken,
        email: null,
        password: null,
        name: name,
        termsAccepted: false,
      };
    },
    [emailSignUpSuccess]: (state, { email, password }) => {
      return {
        ...state,
        googleSignUpErrorMessage: null,
        googleIdToken: null,
        email,
        password,
        name: null,
        termsAccepted: false,
      };
    },
    [registrationDone]: (state) => {
      return {
        ...state,
        googleSignUpErrorMessage: null,
        googleIdToken: null,
        email: null,
        password: null,
        name: null,
        termsAccepted: false,
      };
    },
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/ducks/registration.js